import React, { useEffect } from 'react'
import axios from 'axios';
import { useState } from "react";
import { Container, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import imageCompression from "browser-image-compression";
import { useParams } from 'react-router-dom';

export default function Comppembayaran({ kodebooking, kodebooking2, totalharga }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const upload_preset = process.env.REACT_APP_UPLOAD_PRESET;
    const cloud_name = process.env.REACT_APP_CLOUD_NAME;
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState(true);
    const [alertwa, setAlertwa] = useState(false);
    const [norek, setNorek] = useState("");
    const [atasnama, setAtasnam] = useState("");
    const [namateam, setNamateam] = useState('');
    const [nameImg, setNameImg] = useState("");
    const [valueimg, setvalueimg] = useState("");
    const [img, setImg] = useState('')
    const [image, setImage] = useState(null);
    const [loadingUpload, setLoadingUpload] = useState('');
    const [statusKirim, setStatusKirim] = useState();
    const { kode_booking, kode_booking2 } = useParams();
    // const [rr, setRr] = useState(null);

    const raw = localStorage.getItem('bookingData');
    const data = raw ? JSON.parse(raw) : []; // pastikan selalu array
    const idrompi = data.find(item => item.idrompi)?.idrompi || null;
    const idbola = data.find(item => item.idbola)?.idbola || null;
    const idfoto = data.find(item => item.idfoto)?.idfoto || null;
    const idwasit = data.find(item => item.idwasit)?.idwasit || null;


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChangeImg = async (e) => {
        const file = e.target.files[0];
        setImg(e.target.files[0]);
        // console.log(e);
        setvalueimg(e.target.value);
        setNameImg(e.target.files[0].name);
        const options = {
            maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
            maxWidthOrHeight: 800, // Dimensi maksimum
            useWebWorker: true,
        };

        try {
            const compressedFile = await imageCompression(file, options);
            // Pratinjau gambar
            // setPreview(URL.createObjectURL(compressedFile));
            setImage(compressedFile); // Simpan gambar yang sudah dikompres
            setLoadingUpload('berhasil')
            console.log(compressedFile);

        } catch (error) {
            console.error("Gagal mengompres gambar:", error);
        }

    };

    const handleBooking = async () => {
        setLoading(true);
        setForm(false);
        if (!image) return
        const data = new FormData();
        data.append('file', image);
        data.append('upload_preset', upload_preset);
        data.append('cloud_name', cloud_name);

        const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
            method: "POST",
            body: data
        })
        const uploadedImageUrl = await res.json()
        // console.log(uploadedImageUrl.url);
        // setUrlimg(uploadedImageUrl.url)
        addbooking(uploadedImageUrl.url);
    };

    const addbooking = async (url) => {

        await axios
            .post(urlapi + "Layanan", {
                username: localStorage.getItem("nama"),
                iduser: localStorage.getItem("id"),
                bukti: url,
                bank: norek,
                atasnama: atasnama,
                team: namateam,
                foto: idfoto,
                rompi: idrompi,
                wasit: idwasit,
                bola: idbola,
                kode_book1: kodebooking,
                kode_book2: kodebooking2,
                totalharga: totalharga,
            })

            .then((response) => {
                console.log(response.data);
                // sendwa(response.data.kode_booking);
                // resetrankteam();
                // jika berhasil bookign maka localStorage selectedItem di hapus
                setStatusKirim(true);
                setLoading(false);
                localStorage.removeItem('bookingData');
                localStorage.removeItem('totalHarga');

            })
            .catch((error) => {
                // console.log(error.message);
                // setAlertwa(true);
                setLoading(false);
            });

    }


    return (
        <div>
            <Button
                variant="btn rounded-pill"
                onClick={handleShow}
                style={{ backgroundColor: "#2b2e5a", color: "white" }}
            >
                Bayar sekarang
            </Button>

            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                style={{ height: "500px" }}
            >
                <Offcanvas.Header closeButton>
                    <Container>
                        <Offcanvas.Title>Pembayaran Tambah Layanan</Offcanvas.Title>
                    </Container>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Container>
                        {loading ? (
                            <div className="text-center" style={{ marginTop: "150px" }}>
                                <div class="spinner-grow text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <div class="spinner-grow text-secondary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <div class="spinner-grow text-success" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <br></br>
                                <label>Loading....</label>
                                <p className="text-center">
                                    Mohon untuk menunggu proses pembayaran
                                </p>
                            </div>
                        ) : (
                            <div>
                                {form ? (
                                    <>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">

                                            <input type="text" className='form-control fw-bold mb-3' name='kode_booking' value={`Kode Booking : ${kodebooking}`} disabled />
                                            <div className="input-group mb-3">
                                                <span className="input-group-text fw-bold" id="basic-addon1">Rp</span>
                                                <input type="text" class="form-control fw-bold" value={totalharga} aria-describedby="basic-addon1" disabled />
                                            </div>
                                            <input type="text" className='form-control mb-3' onChange={(e) => setNamateam(e.target.value)} placeholder='Masukan nama team anda' />
                                            <select
                                                className="form-control"
                                                required
                                                onChange={(e) => setNorek(e.target.value)}
                                            >
                                                <option value="">-- Pilih Nama Bank Anda --</option>
                                                <option>BRI</option>
                                                <option>BNI</option>
                                                <option>BCA</option>
                                                <option>Mandiri</option>
                                                <option>Bank Sumut</option>
                                                <option>Danamon</option>
                                                <option>CIMB Niaga</option>
                                                <option>Lainya</option>
                                            </select>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Control
                                                type="text"
                                                onChange={(e) => setAtasnam(e.target.value)}
                                                placeholder="Atas nama"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicupload">
                                            <label
                                                for="images"
                                                class="drop-container"
                                                id="dropcontainer"
                                            >
                                                <span class="drop-title">
                                                    {nameImg == "" ? (
                                                        "Upload bukti pembayaran"
                                                    ) : loadingUpload == 'load' ? <> <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div> Loading .....</> : loadingUpload == 'berhasil' ? <>
                                                        <i class="fa-solid fa-circle-check text-success"></i>{" "}
                                                        Upload sukses
                                                    </>
                                                        : <></>

                                                    }
                                                </span>

                                                <input
                                                    type="file"
                                                    id="images"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={(e) => handleChangeImg(e)}
                                                    required
                                                />
                                            </label>
                                            <small>
                                                Upload bukti pembayaran dengan format Gambar (JPG, JPEG
                                                & PNG)
                                            </small>
                                        </Form.Group>

                                        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                                  <Form.Control
                                    type="file"
                                    onChange={(e) => handleChangeImg(e)}
                                  />
                                  <Form.Text className="text-muted"></Form.Text>
                                </Form.Group> */}

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <textarea
                                                className="form-control"
                                                placeholder="Keterangan"
                                            ></textarea>
                                            <Form.Text className="text-muted"></Form.Text>
                                        </Form.Group>

                                        {valueimg == "" || atasnama == "" || norek == "" || loadingUpload == '' || loadingUpload == 'load' ? (
                                            <button
                                                className="btn w-100 rounded-pill disabled"
                                                style={{ backgroundColor: "#2b2e5a", color: "white" }}
                                            >
                                                Bayar sekarang
                                            </button>
                                        ) : (
                                            <button
                                                className="btn w-100 rounded-pill"
                                                onClick={() => handleBooking()}
                                                style={{ backgroundColor: "#2b2e5a", color: "white" }}
                                            >
                                                Bayar sekarang
                                            </button>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <center>
                                            {statusKirim == false ? (
                                                <div>
                                                    <img
                                                        src="/close.png"
                                                        className="img-fluid"
                                                        alt=""
                                                        style={{ height: "100px" }}
                                                    ></img>
                                                    <h5 className="mt-4 text-secondary">
                                                        <strong>
                                                            Hei, {localStorage.getItem("nama")}{" "}
                                                        </strong>
                                                        <br></br>
                                                        Pembayaran anda gagal, pastikan bukti pembayaran
                                                        terisi dengan benar mohon untuk mencoba lagi
                                                        <center>
                                                            {/* <a
                                                                href={"/formbooking/" + idlapangan}
                                                                className="btn mt-5"
                                                                style={{
                                                                    backgroundColor: "#2b2e5a",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                Coba lagi
                                                            </a> */}
                                                        </center>
                                                    </h5>
                                                </div>
                                            ) : (
                                                <>
                                                    <img
                                                        src="/sukses.png"
                                                        className="img-fluid"
                                                        alt=""
                                                        style={{ height: "100px" }}
                                                    ></img>
                                                    <h5 className="mt-4 text-secondary">
                                                        <strong>
                                                            Hei, {localStorage.getItem("nama")}{" "}
                                                        </strong>
                                                        <br></br>
                                                        Pembayaran anda berhasil dikirim silahkan menunggu
                                                        persetujuan pembayaran anda
                                                    </h5>
                                                    <a
                                                        href={"/layanan/" + kode_booking + "/" + kode_booking2}
                                                        className="btn mt-5"
                                                        style={{
                                                            backgroundColor: "#2b2e5a",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Tutup popup
                                                    </a>
                                                </>
                                            )}
                                        </center>
                                    </>
                                )}
                            </div>
                        )}
                    </Container>
                </Offcanvas.Body>
            </Offcanvas>

        </div >
    )
}
